/**
 * SEO-hjälpare som delas av <SEO />, NyhetDetalj och sitemap-genereringen.
 * Rena funktioner utan React/DOM så de kan köras både i SSG-bygget och i vitest.
 */

/** Googles visningsgräns för meta description (tecken). */
export const META_DESCRIPTION_MAX = 155;

export const SITE_ORIGIN = "https://www.tiego.com";

const SWEDISH_MONTHS: Record<string, string> = {
  jan: "01", feb: "02", mar: "03", apr: "04", maj: "05", jun: "06",
  jul: "07", aug: "08", sep: "09", okt: "10", nov: "11", dec: "12",
};

/**
 * "8 jun 2026" → "2026-06-08" (W3C-datum för sitemap <lastmod>). Samma svenska
 * datumformat som NewsArticle.date; ogiltigt format → undefined.
 * (NyhetDetalj har en egen toIsoDate() med tidsstämpel för JSON-LD.)
 */
export function toIsoDay(swedishDate: string): string | undefined {
  const [day, mon, year] = swedishDate.trim().split(/\s+/);
  const mm = SWEDISH_MONTHS[mon?.toLowerCase()];
  if (!mm || !/^\d{1,2}$/.test(day ?? "") || !/^\d{4}$/.test(year ?? "")) return undefined;
  return `${year}-${mm}-${day.padStart(2, "0")}`;
}

/**
 * Klipper en beskrivning till max `max` tecken vid sista ordgränsen och avslutar med "…".
 * Text som redan ryms returneras orörd (trimmad). Skiljetecken direkt före klippet tas bort
 * så resultatet inte blir "…, …".
 */
export function clampDescription(text: string, max: number = META_DESCRIPTION_MAX): string {
  const trimmed = text.replace(/\s+/g, " ").trim();
  if (trimmed.length <= max) return trimmed;

  const limit = max - 1; // plats för "…"
  const head = trimmed.slice(0, limit);
  const lastSpace = head.lastIndexOf(" ");
  const cut = lastSpace > limit * 0.6 ? head.slice(0, lastSpace) : head;
  return cut.replace(/[\s,;:.!?–-]+$/, "") + "…";
}
